var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.25442",
      "ably-hubspot-js": "static-2.2638",
      "breadcrumbs-ui": "static-1.628",
      "enviro": "static-4.282",
      "head-dlb": "static-1.3106",
      "hs-lodash": "static-4.9",
      "hs-promise-utils": "static-1.3528",
      "hs-test-utils": "static-1.6029",
      "hub-http": "static-1.4150",
      "hubspot-url-utils": "static-1.2537",
      "HubStyleTokens": "static-2.9524",
      "I18n": "static-7.1326",
      "jasmine-runner": "static-1.4400",
      "nav-meta": "static-1.24235",
      "navigation-messaging": "static-1.1925",
      "navigation-components": "static-1.12598",
      "navigation-components-tests": "static-1.9208",
      "quartz": "static-1.4747",
      "react": "static-7.133",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "webpack-env": "static-1.41",
      "wootric-nps": "static-1.5078",
      "ably": "static-2.2",
      "calling-internal-common": "static-1.29117",
      "classnames": "static-2.10",
      "crosstab": "static-1.2666",
      "ExtensionInstallHelpers": "static-1.515",
      "foundations-components": "static-1.5004",
      "foundations-theming": "static-1.2170",
      "foundations-theming-base": "static-1.1155",
      "frontend-preferences-client": "static-1.5921",
      "global-search-externals": "static-1.8220",
      "idb-keyval": "static-1.17",
      "magpie-lib": "static-1.3639",
      "magpie-types": "static-1.3099",
      "metrics-js": "static-1.7794",
      "nav-onboarding-tours": "static-1.1301",
      "notification-sounds": "static-1.2500",
      "prefetcher": "static-1.3810",
      "react-dom": "static-7.85",
      "react-utils": "static-2.3700",
      "redux-thunk": "static-2.17",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.6241",
      "simple-logging-lib": "static-1.1119",
      "styled-components": "static-2.40",
      "superstore": "static-1.2841",
      "trial-components-library": "static-1.9635",
      "ts-schema": "static-1.2525",
      "ui-images": "static-2.777",
      "usage-tracker-core": "static-1.5372",
      "hs-promise-rejection-tracking": "static-1.3457",
      "PortalIdParser": "static-2.260",
      "raven": "static-3.3792",
      "raven-hubspot": "static-1.4099",
      "bend-plugin-trellis-migration": "static-1.1770",
      "moment": "static-3.26",
      "quartz-core": "static-1.3966",
      "HeadJS": "static-2.529",
      "framer-motion": "static-1.34",
      "hs-test-utils-bend-plugin": "static-1.1140",
      "msw": "static-1.39",
      "testing-library": "static-1.117",
      "i18n-data": "static-1.193",
      "moment-timezone": "static-5.47",
      "jasmine": "static-4.2413",
      "quartz-core-utils": "static-1.1614",
      "StyleGuideUI": "static-3.440",
      "csstype": "static-1.8",
      "hoist-non-react-statics": "static-3.9",
      "HubStyle": "static-2.9833",
      "calling-error-reporting": "static-1.29123",
      "calling-usage-tracker": "static-1.4524",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "quick-fetch": "static-1.2224",
      "self-service-api": "static-1.8158",
      "SharedI18nStrings": "static-1.160",
      "UIComponents": "static-3.6473",
      "bend-plugin-foundations-components": "static-1.1272",
      "floating-ui": "static-1.23",
      "foundations-assets": "static-1.2968",
      "hs-story-utils": "static-1.7289",
      "react-aria": "static-1.35",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.70",
      "tanstack-table": "static-1.10",
      "ui-fonts": "static-1.328",
      "bend-plugin-foundations-theming": "static-1.653",
      "global-search-shared": "static-1.8932",
      "usage-tracker": "static-1.5522",
      "autolinker": "static-3.11",
      "sanitize": "static-1.2426",
      "transmute": "static-2.29",
      "ai-components-ui-library": "static-1.4203",
      "atom": "static-1.3393",
      "copilot-toolkit": "static-1.3841",
      "demographics-client": "static-1.3459",
      "icons": "static-2.586",
      "laboratory-lib": "static-3.5310",
      "onboarding-scopes": "static-1.4613",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.2798",
      "salesImages": "static-1.494",
      "signup-constants": "static-1.14824",
      "trials-service-types": "static-1.2234",
      "ui-addon-i18n": "static-1.8937",
      "ui-addon-upgrades": "static-9.14963",
      "user-context": "static-1.3193",
      "dispatcher": "static-1.108",
      "general-store": "static-6.20",
      "history": "static-4.15",
      "hub-http-janus": "static-1.597",
      "hub-http-shared-msw-handlers": "static-1.6105",
      "hubspotter-http": "static-1.2905",
      "hubspotter-http-shared-msw-handlers": "static-1.6103",
      "mobile-manifest-mixins": "static-1.300",
      "platform-navigation-bootstrap": "static-1.10184",
      "react-rhumb": "static-1.14595",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.325",
      "customer-data-ui-utilities": "static-1.7699",
      "ai-addon-copilot-preview": "static-1.3415",
      "apollo-link-hub-http": "static-2.2857",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.7488",
      "graphql": "static-1.55",
      "search-service-types": "static-1.2162",
      "chatspot-client-types": "static-1.7357",
      "chatspot-core": "static-1.12986",
      "ContentUtils": "static-1.60872",
      "sassPrefix": "static-1.124",
      "feature-store-service-types": "static-1.2826",
      "growth-monetization-service-types": "static-1.2833",
      "upgrade-management-service-types": "static-1.2817",
      "getting-started-shared-tasks": "static-1.9081",
      "getting-started-shared-tasks-store": "static-1.8199",
      "platform-infra-nav-components": "static-1.6035",
      "react-dnd-compat": "static-1.2580",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.4810",
      "apollo-dlb": "static-3.41",
      "cms-field-types": "static-1.2845",
      "content-icons-ui": "static-1.1828",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.7436",
      "ui-addon-react-router-dom": "static-1.7649",
      "usage-tracker-container": "static-1.5512"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.25442",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.2638",
      "breadcrumbs-ui": "/breadcrumbs-ui/static-1.628",
      "enviro": "/enviro/static-4.282",
      "head-dlb": "/head-dlb/static-1.3106",
      "hs-lodash": "/hs-lodash/static-4.9",
      "hs-promise-utils": "/hs-promise-utils/static-1.3528",
      "hs-test-utils": "/hs-test-utils/static-1.6029",
      "hub-http": "/hub-http/static-1.4150",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2537",
      "HubStyleTokens": "/HubStyleTokens/static-2.9524",
      "I18n": "/I18n/static-7.1326",
      "jasmine-runner": "/jasmine-runner/static-1.4400",
      "nav-meta": "/nav-meta/static-1.24235",
      "navigation-messaging": "/navigation-messaging/static-1.1925",
      "navigation-components": "/navigation-components/static-1.12598",
      "navigation-components-tests": "/navigation-components-tests/static-1.9208",
      "quartz": "/quartz/static-1.4747",
      "react": "/react/static-7.133",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "webpack-env": "/webpack-env/static-1.41",
      "wootric-nps": "/wootric-nps/static-1.5078",
      "ably": "/ably/static-2.2",
      "calling-internal-common": "/calling-internal-common/static-1.29117",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.2666",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.515",
      "foundations-components": "/foundations-components/static-1.5004",
      "foundations-theming": "/foundations-theming/static-1.2170",
      "foundations-theming-base": "/foundations-theming-base/static-1.1155",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.5921",
      "global-search-externals": "/global-search-externals/static-1.8220",
      "idb-keyval": "/idb-keyval/static-1.17",
      "magpie-lib": "/magpie-lib/static-1.3639",
      "magpie-types": "/magpie-types/static-1.3099",
      "metrics-js": "/metrics-js/static-1.7794",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.1301",
      "notification-sounds": "/notification-sounds/static-1.2500",
      "prefetcher": "/prefetcher/static-1.3810",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.3700",
      "redux-thunk": "/redux-thunk/static-2.17",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.6241",
      "simple-logging-lib": "/simple-logging-lib/static-1.1119",
      "styled-components": "/styled-components/static-2.40",
      "superstore": "/superstore/static-1.2841",
      "trial-components-library": "/trial-components-library/static-1.9635",
      "ts-schema": "/ts-schema/static-1.2525",
      "ui-images": "/ui-images/static-2.777",
      "usage-tracker-core": "/usage-tracker-core/static-1.5372",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3457",
      "PortalIdParser": "/PortalIdParser/static-2.260",
      "raven": "/raven/static-3.3792",
      "raven-hubspot": "/raven-hubspot/static-1.4099",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.1770",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.3966",
      "HeadJS": "/HeadJS/static-2.529",
      "framer-motion": "/framer-motion/static-1.34",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1140",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.117",
      "i18n-data": "/i18n-data/static-1.193",
      "moment-timezone": "/moment-timezone/static-5.47",
      "jasmine": "/jasmine/static-4.2413",
      "quartz-core-utils": "/quartz-core-utils/static-1.1614",
      "StyleGuideUI": "/StyleGuideUI/static-3.440",
      "csstype": "/csstype/static-1.8",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "HubStyle": "/HubStyle/static-2.9833",
      "calling-error-reporting": "/calling-error-reporting/static-1.29123",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.4524",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "quick-fetch": "/quick-fetch/static-1.2224",
      "self-service-api": "/self-service-api/static-1.8158",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.160",
      "UIComponents": "/UIComponents/static-3.6473",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.1272",
      "floating-ui": "/floating-ui/static-1.23",
      "foundations-assets": "/foundations-assets/static-1.2968",
      "hs-story-utils": "/hs-story-utils/static-1.7289",
      "react-aria": "/react-aria/static-1.35",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.70",
      "tanstack-table": "/tanstack-table/static-1.10",
      "ui-fonts": "/ui-fonts/static-1.328",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.653",
      "global-search-shared": "/global-search-shared/static-1.8932",
      "usage-tracker": "/usage-tracker/static-1.5522",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.2426",
      "transmute": "/transmute/static-2.29",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.4203",
      "atom": "/atom/static-1.3393",
      "copilot-toolkit": "/copilot-toolkit/static-1.3841",
      "demographics-client": "/demographics-client/static-1.3459",
      "icons": "/icons/static-2.586",
      "laboratory-lib": "/laboratory-lib/static-3.5310",
      "onboarding-scopes": "/onboarding-scopes/static-1.4613",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.2798",
      "salesImages": "/salesImages/static-1.494",
      "signup-constants": "/signup-constants/static-1.14824",
      "trials-service-types": "/trials-service-types/static-1.2234",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.8937",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.14963",
      "user-context": "/user-context/static-1.3193",
      "dispatcher": "/dispatcher/static-1.108",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.15",
      "hub-http-janus": "/hub-http-janus/static-1.597",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6105",
      "hubspotter-http": "/hubspotter-http/static-1.2905",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6103",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.300",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.10184",
      "react-rhumb": "/react-rhumb/static-1.14595",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.325",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.7699",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.3415",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.2857",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.7488",
      "graphql": "/graphql/static-1.55",
      "search-service-types": "/search-service-types/static-1.2162",
      "chatspot-client-types": "/chatspot-client-types/static-1.7357",
      "chatspot-core": "/chatspot-core/static-1.12986",
      "ContentUtils": "/ContentUtils/static-1.60872",
      "sassPrefix": "/sassPrefix/static-1.124",
      "feature-store-service-types": "/feature-store-service-types/static-1.2826",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.2833",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.2817",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.9081",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.8199",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6035",
      "react-dnd-compat": "/react-dnd-compat/static-1.2580",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.4810",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "cms-field-types": "/cms-field-types/static-1.2845",
      "content-icons-ui": "/content-icons-ui/static-1.1828",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.7436",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.7649",
      "usage-tracker-container": "/usage-tracker-container/static-1.5512"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};